import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, dashboard } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('signal_token');
    if (token) {
      auth.me()
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('signal_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await auth.login({ email, password });
    localStorage.setItem('signal_token', res.data.token);
    setUser(res.data.user);
    // Auto-trigger first sync if workspace has no data yet (fire and forget)
    if (res.data.needsSync) {
      dashboard.sync().catch(() => {});
    }
    return res.data;
  };

  const signup = async (data) => {
    const res = await auth.signup(data);
    localStorage.setItem('signal_token', res.data.token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('signal_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
